export default "__VITE_ASSET__CaCLscTQ__"